module.exports = __webpack_public_path__ + "img/5, Quiz_7 -Mentee.364385bf.jpg";